// src/main.js

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import './assets/tailwind.css'; // Asegúrate de tener Tailwind CSS importado
import "toastify-js/src/toastify.css";
import "./assets/custom.css";
import 'material-icons/iconfont/material-icons.css';

const pinia = createPinia();

createApp(App)
    .use(pinia)
    .use(router)
    .mount('#app');